import { ErrorParser } from "../ErrorParser";
import { isObject } from "lodash-es";

/**
 * Ej: Country does not have nse levels
 */
export class PaisSinNivelesNseParser implements ErrorParser {
    public puedeLeerError(error: string): boolean {
        return !isObject(error) && error.includes("Country does not have nse levels");
    }

    public traducir(): string {
        return "El pais seleccionado no contiene niveles socioeconomicos asociados";
    }
}
